// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.init-module__dsAccented--ftfKE,.init-module__dsAccented--ftfKE *{font-weight:500}.init-module__dsDefaultWeight--NbK1F,.init-module__dsDefaultWeight--NbK1F *{font-weight:400}h5.init-module__dsAccented--ftfKE,h5.init-module__dsAccented--ftfKE *{font-weight:700}.init-module__dsUnderline--idQiG,.init-module__dsUnderline--idQiG *{text-decoration:underline}.init-module__dsAccented2--egUxJ,.init-module__dsAccented2--egUxJ *{font-weight:700}.init-module__dsBodyXL--AZBt2,.init-module__dsBodyXL--AZBt2 *{font-size:18px;line-height:27px}.init-module__dsBodyLarge--pfGXt,.init-module__dsBodyLarge--pfGXt *{font-size:16px;line-height:24px}.init-module__dsBody--qDq8E,.init-module__dsBody--qDq8E *{font-size:14px;line-height:20px}.init-module__dsBodySmall--vrzW0,.init-module__dsBodySmall--vrzW0 *{font-size:12px;line-height:18px}.init-module__dsBodyXS--TH00L,.init-module__dsBodyXS--TH00L *{font-size:10px;line-height:15px}.init-module__dsActionLarge--y03tP,.init-module__dsActionLarge--y03tP *{font-size:16px;line-height:18px}.init-module__dsAction--Akiaw,.init-module__dsAction--Akiaw *{font-size:14px;line-height:16px}.init-module__dsActionSmall--a1Brx,.init-module__dsActionSmall--a1Brx *{font-size:12px;line-height:14px}.init-module__dsColumnHeadLine--yYrXe,.init-module__dsColumnHeadLine--yYrXe *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.init-module__dsLightXL--Cdh1p,.init-module__dsLightXL--Cdh1p *{font-size:120px;line-height:160px;font-weight:300}.init-module__dsLightLarge--x9FlI,.init-module__dsLightLarge--x9FlI *{font-size:48px;line-height:64px;font-weight:300}.init-module__dsLight--EdG_d,.init-module__dsLight--EdG_d *{font-size:32px;line-height:64px;font-weight:300}.init-module__dsLightSmall--CzMym,.init-module__dsLightSmall--CzMym *{font-size:24px;line-height:36px;font-weight:300}.init-module__dsLightXS--rmp98,.init-module__dsLightXS--rmp98 *{font-size:18px;line-height:27px;font-weight:300}*{letter-spacing:.02em}body{font-family:Roboto,sans-serif}code,code span{font-family:monospace}p{margin:0}h1{font-size:32px;font-weight:500;line-height:48px}h2{font-size:26px;line-height:39px;font-weight:500}h3{font-size:22px;line-height:33px;font-weight:500}h4{font-size:18px !important;line-height:27px !important;font-weight:500 !important}h5{font-size:16px;line-height:24px;font-weight:500}h6{font-size:14px;line-height:20px;font-weight:500}button,input,textarea{font-size:inherit;font-family:inherit;font-weight:inherit}textarea{font-family:inherit !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsAccented": `init-module__dsAccented--ftfKE`,
	"dsDefaultWeight": `init-module__dsDefaultWeight--NbK1F`,
	"dsUnderline": `init-module__dsUnderline--idQiG`,
	"dsAccented2": `init-module__dsAccented2--egUxJ`,
	"dsBodyXL": `init-module__dsBodyXL--AZBt2`,
	"dsBodyLarge": `init-module__dsBodyLarge--pfGXt`,
	"dsBody": `init-module__dsBody--qDq8E`,
	"dsBodySmall": `init-module__dsBodySmall--vrzW0`,
	"dsBodyXS": `init-module__dsBodyXS--TH00L`,
	"dsActionLarge": `init-module__dsActionLarge--y03tP`,
	"dsAction": `init-module__dsAction--Akiaw`,
	"dsActionSmall": `init-module__dsActionSmall--a1Brx`,
	"dsColumnHeadLine": `init-module__dsColumnHeadLine--yYrXe`,
	"dsLightXL": `init-module__dsLightXL--Cdh1p`,
	"dsLightLarge": `init-module__dsLightLarge--x9FlI`,
	"dsLight": `init-module__dsLight--EdG_d`,
	"dsLightSmall": `init-module__dsLightSmall--CzMym`,
	"dsLightXS": `init-module__dsLightXS--rmp98`
};
module.exports = ___CSS_LOADER_EXPORT___;
